import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ElementName } from '../../../../../constants';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseTextElement, toTextProps } from '../common';
var TargetBranchElement = function TargetBranchElement(props) {
  var context = useFlexibleUiContext();
  var data = context ? toTextProps(context.targetBranch) : null;
  return data ? /*#__PURE__*/React.createElement(BaseTextElement, _extends({}, data, props, {
    name: ElementName.TargetBranch
  })) : null;
};
export default TargetBranchElement;